<template>
  <div id="app">
    <electron-menu></electron-menu>
    <router-view></router-view>
    <real-name-auth ref="realNameAuth" @success="onAuthSuccess" ></real-name-auth>
    <!-- 全局消息提醒 -->
    <global-message-notification></global-message-notification>
  </div>
</template>

<script>
import RealNameAuth from "@/components/common/RealNameAuth.vue";
import GlobalMessageNotification from "@/components/common/GlobalMessageNotification.vue";

import ElectronMenu from './components/common/ElectronMenu.vue';
import useConfigStore from './store/configStore';
import realNameAuthService from './utils/realNameAuthService';

import { setLocale } from '@/i18n';
import { applyThemeAccent, getThemeAccent } from '@/api/theme';

export default {
  name: 'App',
  components: {ElectronMenu, RealNameAuth, GlobalMessageNotification},
  created() {
    applyThemeAccent(getThemeAccent());
  },
  mounted() {
    if (window.electronAPI) {
      const configStore = useConfigStore();
      configStore.setElectronMode(true)
      window.electronAPI.invoke('isFullScreen').then(fullScreen => {
        configStore.setFullScreen(fullScreen);
      })
      // 客户端语言优先级：客户手动设置 > 系统语言 > 默认中文
      const locale = localStorage.getItem('im-locale');
      const supportLocales = Object.keys(this.$i18n.messages);
      if (supportLocales.includes(locale)) {
        window.electronAPI.sendEvent('setLocale', locale);
      } else {
        window.electronAPI.invoke('getAppLocale').then(appLocale => {
          console.log("appLocale:",appLocale)
          if(supportLocales.includes(appLocale)){
            setLocale(appLocale)
          }
        })
      }
    }
    window.$showLogin = (callbacks) => {
      return new Promise((resolve, reject) => {
        const successHandler = () => {
          callbacks?.success?.();
          resolve();
          window.$loginDialog = null;
        };
        const closeHandler = () => {
          callbacks?.cancel?.();
          reject();
          window.$loginDialog = null;
        };
        window.$loginDialog = {
          hide: () => {
            if (this.$router.currentRoute.path === '/login') {
              this.$router.back();
            }
          },
          onSuccess: successHandler,
          onClose: closeHandler,
        };
        const redirect = this.$router.currentRoute.fullPath;
        if (this.$router.currentRoute.path !== '/login') {
          this.$router.push({ path: '/login', query: { redirect } });
        }
      });
    };

    // 全局实名认证显示方法
    window.$checkRealNameAuth = () => {
      this.checkRealNameAuthOnStartup();
    };
    window.$showRealNameAuth = (force) => {
      this.$refs.realNameAuth.show(force);
    };
    if(sessionStorage.getItem("accessToken") && !this.userStore?.userInfo.id){
      this.userStore.loadUser().then(() => {
         this.userStore.loadUser();
         this.$db.open(this.userStore.userInfo.id);
        // 加载好友要在加载会话前面，否则好友在线状态不显示
         this.friendStore.loadFriend();
        const promises = [];
        promises.push(this.groupStore.loadGroup());
        promises.push(this.configStore.loadConfig());
        promises.push(this.chatStore.loadConversations());
        return Promise.all(promises);
      })
    }
  },
  methods: {
    // 应用启动时检查实名认证
    checkRealNameAuthOnStartup() {
      if (this.userStore.userInfo && realNameAuthService.needRealNameAuth(this.userStore.userInfo)) {
        // 延迟显示提示，避免与登录流程冲突
        setTimeout(() => {
          realNameAuthService.showAuthPrompt(
            () => {
              // 用户选择立即认证
              this.$refs.realNameAuth.show();
            },
            () => {
              // 用户选择稍后再说
              console.log('用户选择稍后认证');
            }
          );
        }, 1000);
      }
    },

    // 实名认证成功回调
    async onAuthSuccess() {
      // 重新加载用户信息
      await this.userStore.loadUser();
    }
  }
}
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  height: 100%;
  width: 100%;
  color: var(--im-text-color);
  font-family: var(--im-font-family);
  overflow: auto;
}
</style>
